module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Lamp1-397e70cc9a895e70f5b1bffe97fe3cac.svg";